// extracted by mini-css-extract-plugin
module.exports = {"root":"IndexPage_root__3ZSC9","loading":"IndexPage_loading__1sHJS","error":"IndexPage_error__1L5TN"};